import React, { Component } from 'react'
import axios from 'axios'
import DatePicker from 'react-datepicker'
import {
  APIURL,
  IMAGE_FULL_URL,
  IMAGE_UPLOAD_ERROR,
  PORT
} from '../../../config/config'
import { connect } from 'react-redux'
import MaskedInput  from 'react-maskedinput'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import NumberFormat from 'react-number-format'
import 'moment/locale/th'
import Loading from '../../Loading'
moment.locale('th')

var randomString = require('random-string')
var port = window.env.PORT;

class CarNew extends Component {

  constructor (props) {
    super(props)

    this.state = {
      lists: [],
      car_brands: [],
      car_models: [],
      car_sub_models: [],
      car_years: [],
      car_colors: [],
      car_gears: [],
      car_status: [],
      car_name_owner_old: [],
      province: [],
      branch: [],
      car_hassock: [],
      car_system_drive: [],
      car_type_engine: [],
      car_type: [],
      car_structure: [],
      load_data: true,
      danger: false,
      car_id: 0,
      action: 'บันทึก',
      car: '',
      upload_code: '',
      // startDateCarNew1: moment().format('YYYY-MM-DD'),
      startDateCarNew2: null,
      startDateCarNew3: null,
      car_date_in: new Date(),
      car_cost: 0,
      car_sale_price: 0,
      car_cost_repair: 0,
      car_cost_tax: 0,
      car_cost_act: 0,
      car_cost_commissions: 0,
      car_cost_expenses_other: 0,
      car_cost_recipe_other: 0,
      car_net_profit: 0,
      user: {},
      car_name: '',
      car_detail: '',
      tmp_car_brand: '',
      tmp_car_model: '',
      tmp_car_sub_model: '',
      tmp_car_year: '',
      tmp_car_gear: '',
      tmp_car_color: '',
      car_miles: 0,
      //
      floorplan_credit: 0,
      banks: [],
      insurance_companies: [],
      insurance_types: [],
      floorplan_due_date: null,
      receipt_date: null,
      //
      form_controls: [],
      insurance_end_date: null,
      compulsory_insurance_end_date: null,
      isLoading: false
    }

    this.handleOnSubmitCar = this.handleOnSubmitCar.bind(this)
    this.handleUploadFile = this.handleUploadFile.bind(this)
    this.handleUploadFile2 = this.handleUploadFile2.bind(this)
    this.handleDateCarNew1 = this.handleDateCarNew1.bind(this)
    this.handleDateCarNew2 = this.handleDateCarNew2.bind(this)
    this.handleDateCarNew3 = this.handleDateCarNew3.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)

    this.handleCarSubModelChange = this.handleCarSubModelChange.bind(this)
    this.handleCarNameChange = this.handleCarNameChange.bind(this)
    this.handleCarGearChange = this.handleCarGearChange.bind(this)
    this.handleCarColorChange = this.handleCarColorChange.bind(this)
    this.handleCarDetailChange = this.handleCarDetailChange.bind(this)
    this.handleCarFeatureCheck = this.handleCarFeatureCheck.bind(this)

    this.convertBBtoCC = this.convertBBtoCC.bind(this)
    this.onMaskedChange1 = this.onMaskedChange1.bind(this)
    this.onMaskedChange2 = this.onMaskedChange2.bind(this)
    this.onMaskedChange3 = this.onMaskedChange3.bind(this)

    this.handleOnChangeNoSet = this.handleOnChangeNoSet.bind(this)
    this.handleCarDateIn = this.handleCarDateIn.bind(this)
    this.loadBanks = this.loadBanks.bind(this)
    this.loadInsuranceCompanies = this.loadInsuranceCompanies.bind(this)
    this.loadInsuranceType = this.loadInsuranceType.bind(this)
    this.handleFloorplanDueDate = this.handleFloorplanDueDate.bind(this)
    this.handleReceiptDate = this.handleReceiptDate.bind(this)
    //
    this.loadFormControls = this.loadFormControls.bind(this)
    this.handleInsuranceEndDate = this.handleInsuranceEndDate.bind(this)
    this.handleCompulsoryInsuranceEndDate = this.handleCompulsoryInsuranceEndDate.bind(this)
  }

  handleOnSubmitCar (event) {
    event.preventDefault()

    let car_upload_code = this.state.upload_code
    let car_name_owner_old = event.target.car_name_owner_old.value
    let car_lastname_owner_old = event.target.car_lastname_owner_old.value
    let car_id_card = event.target.car_id_card.value
    let car_license_plate_old = event.target.car_license_plate_old.value
    let province_old_id = event.target.province_old_id.value
    let car_telephone_old = event.target.car_telephone_old.value
    let car_address_old = event.target.car_address_old.value
    let car_other = event.target.car_other.value
    let branch_id = event.target.branch_id.value
    //let car_date_in = event.target.car_date_in.value
    //let car_date_in = this.state.startDateCarNew1
    let car_date_in = this.state.car_date_in
    let car_name = event.target.car_name.value
    let car_detail = event.target.car_detail.value
    let car_brand_id = event.target.car_brand_id.value
    let car_model_id = event.target.car_model_id.value
    let car_sub_model_id = event.target.car_sub_model_id.value
    let car_year_id = event.target.car_year_id.value
    let car_color_id = event.target.car_color_id.value
    let car_gear_id = event.target.car_gear_id.value
    let car_license_plate_new = event.target.car_license_plate_new.value
    let province_new_id = event.target.province_new_id.value
    let car_miles = event.target.car_miles.value
    let car_number = event.target.car_number.value
    let car_num_engines = event.target.car_num_engines.value
    //let car_date_regis = event.target.car_date_regis.value

    let car_date_regis = event.target.car_date_regis_text.value === "" ? "" : this.state.startDateCarNew3
    let car_date_tax = event.target.car_date_tax_text.value === "" ? "" : this.state.startDateCarNew2

    //console.log()

    let car_type_id = event.target.car_type_id.value
    let car_structure_id = event.target.car_structure_id.value
    let car_hassock_id = event.target.car_hassock_id.value
    let car_system_drive_id = event.target.car_system_drive_id.value
    let car_type_engine_id = event.target.car_type_engine_id.value
    let car_brand_engine = event.target.car_brand_engine.value
    let car_gas_number = event.target.car_gas_number.value
    let car_weight = event.target.car_weight.value
    let car_size_engine = event.target.car_size_engine.value
    //let car_date_tax = event.target.car_date_tax.value

    let car_tax = event.target.car_tax.value
    let car_status_id = event.target.car_status_id.value
    let car_cost = event.target.car_cost.value
    let car_sale_price = event.target.car_sale_price.value
    let car_cost_repair = event.target.car_cost_repair.value
    let car_cost_tax = event.target.car_cost_tax.value
    let car_cost_act = event.target.car_cost_act.value
    let car_cost_commissions = event.target.car_cost_commissions.value
    let car_cost_expenses_other = event.target.car_cost_expenses_other.value
    let car_cost_recipe_other = event.target.car_cost_recipe_other.value
    let car_net_profit = event.target.car_net_profit.value
    //pisan
    let liciense_status_id = event.target.liciense_status_id.value
    let finance_id = event.target.finance_id.value
    let floorplan_credit = event.target.floorplan_credit.value
    let finance_floorplan_id = event.target.finance_floorplan_id.value
    let insurance_type_id = event.target.insurance_type_id.value
    let insurance_company_id = event.target.insurance_company_id.value
    let floorplan_due_date = event.target.floorplan_due_date.value
    let receipt_date = event.target.receipt_date.value
    let deposit_registration_id = event.target.deposit_registration_id.value
    //
    let insurance_end_date = event.target.insurance_end_date.value
    let compulsory_insurance = event.target.compulsory_insurance.value
    let compulsory_insurance_company = event.target.compulsory_insurance_company.value
    let compulsory_insurance_end_date = event.target.compulsory_insurance_end_date.value
    let car_spare_key = event.target.car_spare_key.value
    let car_manual = event.target.car_manual.value

    /*var test = {
      car_date_tax : car_date_tax,
      car_date_regis: car_date_regis,
      compulsory_insurance_end_date: compulsory_insurance_end_date
    }
    console.log(test); return;*/

    var img_front_car_url = this.refs.img_front_car.src

    if (car_name_owner_old === '') {
      alert('กรุณากรอกข้อมูลเจ้าของเดิม')
      this.refs.car_name_owner_old.focus()
      return
    }
    if (car_license_plate_old === '') {
      alert('กรุณากรอกป้ายทะเบียนเดิม')
      this.refs.car_license_plate_old.focus()
      return
    }

    if (branch_id === '') {
      alert('กรุณาเลือกสาขาที่รถอยู่')
      this.refs.branch_id.focus()
      return
    }


    if (car_brand_id === '') {
      alert('กรุณาเลือกยี่ห้อรถ')
      this.refs.car_brand_id.focus()
      return
    }
    if (car_model_id === '') {
      alert('กรุณาเลือกรุ่นรถ')
      return
    }
    if (car_sub_model_id === '') {
      alert('กรุณาเลือกรุ่นย่อย')
      return
    }

    if(img_front_car_url.indexOf('add_image') >= 0){
      alert('กรุณาเลือกภาพหน้ารถ')
      return
    }


    this.setState({
      isLoading: true
    })

    axios.post(APIURL + '/car/', {
      car_upload_code: car_upload_code,
      car_name_owner_old: car_name_owner_old,
      car_lastname_owner_old: car_lastname_owner_old,
      car_id_card: car_id_card,
      car_license_plate_old: car_license_plate_old,
      province_old_id: province_old_id,
      car_telephone_old: car_telephone_old,
      car_address_old: car_address_old,
      car_other: car_other,
      branch_id: branch_id,
      car_date_in: car_date_in,
      car_name: car_name,
      car_detail: car_detail,
      car_brand_id: car_brand_id,
      car_model_id: car_model_id,
      car_sub_model_id: car_sub_model_id,
      car_gear_id: car_gear_id,
      car_color_id: car_color_id,
      car_year_id: car_year_id,
      car_license_plate_new: car_license_plate_new,
      province_new_id: province_new_id,
      car_miles: car_miles,
      car_number: car_number,
      car_num_engines: car_num_engines,
      car_date_regis: car_date_regis,
      car_type_id: car_type_id,
      car_structure_id: car_structure_id,
      car_hassock_id: car_hassock_id,
      car_system_drive_id: car_system_drive_id,
      car_type_engine_id: car_type_engine_id,
      car_brand_engine: car_brand_engine,
      car_gas_number: car_gas_number,
      car_weight: car_weight,
      car_size_engine: car_size_engine,
      car_date_tax: car_date_tax,
      car_tax: car_tax,
      car_status_id: car_status_id,
      car_cost: car_cost,
      car_sale_price: car_sale_price,
      car_cost_repair: car_cost_repair,
      car_cost_tax: car_cost_tax,
      car_cost_act: car_cost_act,
      car_cost_commissions: car_cost_commissions,
      car_cost_expenses_other: car_cost_expenses_other,
      car_cost_recipe_other: car_cost_recipe_other,
      car_net_profit: car_net_profit,
      user_created: this.state.user.user,
      user_updated: this.state.user.user,
      //
      liciense_status_id: liciense_status_id,
      finance_id: finance_id,
      floorplan_credit: floorplan_credit,
      finance_floorplan_id: finance_floorplan_id,
      insurance_type_id: insurance_type_id,
      insurance_company_id: insurance_company_id,
      floorplan_due_date: floorplan_due_date,
      receipt_date: receipt_date,
      deposit_registration_id: deposit_registration_id,
      //
      insurance_end_date : insurance_end_date,
      compulsory_insurance : compulsory_insurance,
      compulsory_insurance_company : compulsory_insurance_company,
      compulsory_insurance_end_date : compulsory_insurance_end_date,
      car_spare_key : car_spare_key,
      car_manual : car_manual,
    })
      .then(res => {

        this.setState({
          isLoading: false
        }, () => this.props.history.push('/cars/list'))

      })
      .catch(error => {
        console.log(error)
        alert('error' + error)
      })
  }

  clearForm (event) {
    event.target.car_name_owner_old.value = ''
    event.target.car_lastname_owner_old.value = ''
    event.target.car_id_card.value = ''
    event.target.car_license_plate_old.value = ''
    event.target.province_old_id.value = ''
    event.target.car_telephone_old.value = ''
    event.target.car_address_old.value = ''
    event.target.car_other.value = ''
    event.target.branch_id.value = ''
    //event.target.car_date_in.value = ""
    event.target.car_name.value = ''
    event.target.car_detail.value = ''
    event.target.car_brand_id.value = ''
    event.target.car_model_id.value = ''
    event.target.car_sub_model_id.value = ''
    event.target.car_year_id.value = ''
    event.target.car_color_id.value = ''
    event.target.car_gear_id.value = ''
    event.target.car_license_plate_new.value = ''
    event.target.province_new_id.value = ''
    event.target.car_miles.value = ''
    event.target.car_number.value = ''
    event.target.car_num_engines.value = ''
    //event.target.car_date_regis.value = ""
    event.target.car_type_id.value = ''
    event.target.car_structure_id.value = ''
    event.target.car_hassock_id.value = ''
    event.target.car_system_drive_id.value = ''
    event.target.car_type_engine_id.value = ''
    event.target.car_brand_engine.value = ''
    event.target.car_gas_number.value = ''
    event.target.car_weight.value = ''
    event.target.car_size_engine.value = ''
    //event.target.car_date_tax.value = ""
    event.target.car_tax.value = ''
    event.target.car_status_id.value = ''
    event.target.car_cost.value = ''
    event.target.car_sale_price.value = ''
    event.target.car_cost_repair.value = ''
    event.target.car_cost_tax.value = ''
    event.target.car_cost_act.value = ''
    event.target.car_cost_commissions.value = ''
    event.target.car_cost_expenses_other.value = ''
    event.target.car_cost_recipe_other.value = ''
    event.target.car_net_profit.value = ''
  }

  handleCarBrandChange (event) {
    var car_brand_id = event.target.value
    var car_brand_name = event.target.options[event.target.selectedIndex].text
    var that = this

    axios.get(APIURL + '/car_brand_model/' + car_brand_id)
      .then(res => {
        that.setState({
          car_models: res.data,
          tmp_car_brand: car_brand_name,
          tmp_car_model: '',
          tmp_car_sub_model: '',
        })
        //console.log(res.data)
        that.makeCarName()
      }).catch(error => {
      that.setState({car_models: []})
    })
  }

  makeCarName () {
    var brand = this.state.tmp_car_brand
    var model = this.state.tmp_car_model
    var sub_model = this.state.tmp_car_sub_model
    var year = this.state.tmp_car_year
    var car_name = ''

    if (sub_model !== '') {
      if (sub_model.includes(model)) {
        car_name = brand + ' ' + sub_model
      } else {
        car_name = brand + ' ' + model + ' ' + sub_model
      }
    } else {
      car_name = brand + ' ' + model + ' ' + sub_model
    }

    if (year !== '') {
      car_name += ' ปี ' + year
    }

    this.setState({
      car_name: car_name
    })
  }

  makeCarDetail () {
    var brand = this.state.tmp_car_brand
    var model = this.state.tmp_car_model
    var sub_model = this.state.tmp_car_sub_model
    var year = this.state.tmp_car_year
    var gear = this.state.tmp_car_gear
    var color = this.state.tmp_car_color
    //var car_detail = brand+" "+model+" "+sub_model

    var car_detail = ''

    if (sub_model !== '') {
      if (sub_model.includes(model)) {
        car_detail = brand + ' ' + sub_model
      } else {
        car_detail = brand + ' ' + model + ' ' + sub_model
      }
    } else {
      car_detail = brand + ' ' + model + ' ' + sub_model
    }

    if (year !== '')
      car_detail += ' ปี ' + year

    if (gear !== '')
      car_detail += ' ' + gear

    if (color !== '')
      car_detail += ' สี ' + color

    this.setState({
      car_detail: car_detail
    })

  }

  handleCarModelChange (event) {
    var car_model_id = event.target.value
    var car_model = event.target.options[event.target.selectedIndex].text
    var that = this
    axios.get(APIURL + '/car_sub_model/' + car_model_id)
      .then(res => {
        that.setState({car_sub_models: res.data, tmp_car_model: car_model})
        that.makeCarName()

      }).catch(error => {
      that.setState({car_sub_models: []})
    })
  }

  handleCarSubModelChange (event) {

    var car_sub_model = event.target.options[event.target.selectedIndex].text
    this.setState({
        tmp_car_sub_model: car_sub_model
      },
      () => {
        this.makeCarName()
      })

  }

  handleCarYearChange (event) {
    var car_year = event.target.options[event.target.selectedIndex].text
    this.setState({tmp_car_year: car_year}, () => {
      this.makeCarName()
      this.makeCarDetail()
    })
  }

  handleCarNameChange () {
    var car_name = this.refs.car_name.value
    this.setState({
      car_name: car_name
    })
  }

  handleCarDetailChange () {
    var car_detail = this.refs.car_detail.value
    this.setState({
      car_name: car_detail
    })
  }

  handleCarGearChange (event) {
    this.setState({tmp_car_gear: event.target.options[event.target.selectedIndex].text}, () => {
      this.makeCarDetail()
    })
  }

  handleCarColorChange (event) {
    this.setState({tmp_car_color: event.target.options[event.target.selectedIndex].text}, () => {
      this.makeCarDetail()
    })
  }

  handleDateCarNew1 (date) {
    //alert (date)
    /*this.setState({
      startDateCarNew1: moment(date).format('YYYY-MM-DD')
    })*/
  }

  handleDateCarNew2 (date) {

    this.setState({
      startDateCarNew2: moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : null
    })

  }

  handleDateCarNew3 (date) {
    //let datebuddha =   new Date(date).add(Date.YEAR , 543);
    //alert (datebuddha);

      this.setState({
        startDateCarNew3: moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : null
      })


  }

  onMaskedChange1 (e) {
    let buddhist_date = e.target.value
    //alert('buddhist_date='+buddhist_date);
    if (buddhist_date.length === 10) {
      let cc_date = this.convertBBtoCC(buddhist_date)
      this.handleDateCarNew1(cc_date)
    }
  }

  onMaskedChange2 (e) {
    let buddhist_date = e.target.value
    //alert('buddhist_date='+buddhist_date);
    if (buddhist_date.length === 10) {
      let cc_date = this.convertBBtoCC(buddhist_date)
      this.handleDateCarNew2(cc_date)
    }
  }

  onMaskedChange3 (e) {
    let buddhist_date = e.target.value
    //alert('buddhist_date='+buddhist_date);
    if (buddhist_date.length === 10) {
      let cc_date = this.convertBBtoCC(buddhist_date)
      this.handleDateCarNew3(cc_date)
    }
  }

  convertBBtoCC (buddhist_date) { //dd-mm-yyyy to yyyy-mm-dd
    let date_arr = buddhist_date.split('-')
    let dd = date_arr[0]
    let mm = date_arr[1]
    let yyyy = date_arr[2] - 543
    let cc_date = yyyy + '-' + mm + '-' + dd
    if (moment(cc_date, 'YYYY-MM-DD', true).isValid()) {
      //alert(cc_date);
      return cc_date
    }
    return moment()
  }

  handleCarFeatureCheck (event) {
    this.setState({checked: !this.state.checked});
  }

  loadCarBrandData () {
    axios.get(APIURL + '/car_brand/')
      .then(res => {
        this.setState({car_brands: res.data})
        //console.log(res.data)
        //alert (res.data)
      }).catch(error => {
      this.setState({car_brands: []})
    })
  }

  loadCarYearData () {
    axios.get(APIURL + '/car_year/')
      .then(res => {
        this.setState({car_years: res.data})
      }).catch(error => {
      this.setState({car_years: []})
    })
  }

  loadCarColorData () {
    axios.get(APIURL + '/car_color/')
      .then(res => {
        this.setState({car_colors: res.data})
      }).catch(error => {
      this.setState({car_colors: []})
    })
  }

  loadCarGearData () {
    axios.get(APIURL + '/car_gear/')
      .then(res => {
        this.setState({car_gears: res.data})
      }).catch(error => {
      this.setState({car_gears: []})
    })
  }

  loadCarStatusData () {
    axios.get(APIURL + '/car_status/new/1')
      .then(res => {
        this.setState({car_status: res.data})
      }).catch(error => {
      this.setState({car_status: []})
    })
  }

  loadProvinceData () {
    axios.get(APIURL + '/province/')
      .then(res => {
        this.setState({province: res.data})
      }).catch(error => {
      this.setState({province: []})
    })
  }

  loadBranchData () {
    axios.get(APIURL + '/branch/')
      .then(res => {
        this.setState({branch: res.data})
      }).catch(error => {
      this.setState({branch: []})
    })
  }

  loadCarHassockData () {
    axios.get(APIURL + '/car_hassock/')
      .then(res => {
        this.setState({car_hassock: res.data})
      }).catch(error => {
      this.setState({car_hassock: []})
    })
  }

  loadCarSystemDriveData () {
    axios.get(APIURL + '/car_system_drive/')
      .then(res => {
        this.setState({car_system_drive: res.data})
      }).catch(error => {
      this.setState({car_system_drive: []})
    })
  }

  loadCarTypeEngineData () {
    axios.get(APIURL + '/car_type_engine/')
      .then(res => {
        this.setState({car_type_engine: res.data})
      }).catch(error => {
      this.setState({car_type_engine: []})
    })
  }

  loadCarTypeData () {
    axios.get(APIURL + '/car_type/')
      .then(res => {
        this.setState({car_type: res.data})
      }).catch(error => {
      this.setState({car_type: []})
    })
  }

  loadCarStructureData () {
    axios.get(APIURL + '/car_structure/')
      .then(res => {
        this.setState({car_structure: res.data})
      }).catch(error => {
      this.setState({car_structure: []})
    })
  }

  loadData () {
    axios.get(APIURL + '/car/')
      .then(res => {
        //alert("res"+res);
        this.setState({lists: res.data,})
      }).catch(error => {
      //alert("error"+error.message);
      this.setState({lists: []})
    })
  }

  loadBanks () {
    axios.get(APIURL + '/bank/')
      .then(res => {
        this.setState({banks: res.data})
      }).catch(error => {
      this.setState({banks: []})
    })
  }

  loadInsuranceCompanies() {
    axios.get(APIURL + '/insurance_company/')
      .then(res => {
        this.setState({insurance_companies: res.data})
      }).catch(error => {
      this.setState({insurance_companies: []})
    })
  }

  //insurance_type
  loadInsuranceType() {
    axios.get(APIURL + '/insurance_type/')
      .then(res => {
        this.setState({insurance_types: res.data})
      }).catch(error => {
      this.setState({insurance_types: []})
    })
  }

  loadFormControls() {
    let tableName = "car";
    axios.get(APIURL + '/form_controls/'+tableName)
      .then(res => {
        this.setState({form_controls: res.data});
      }).catch(error => {
      this.setState({form_controls: []})
    })
  }


  /*shouldComponentUpdate(nextProps) {
   return this.props.user !== nextProps.user;
   }*/

  componentDidMount () {
    //if(this.state.load_data)
    this.loadFormControls()
    this.loadData()
    this.loadCarBrandData()
    this.loadCarYearData()
    this.loadCarColorData()
    this.loadCarGearData()
    this.loadCarStatusData()
    this.loadProvinceData()
    this.loadBranchData()
    this.loadCarHassockData()
    this.loadCarSystemDriveData()
    this.loadCarTypeEngineData()
    this.loadCarTypeData()
    this.loadCarStructureData()
    this.loadBanks()
    this.loadInsuranceType()
    this.loadInsuranceCompanies()


    if (this.state.upload_code === '') {
      var random_code = randomString({
        length: 20,
        numeric: true,
        letters: true,
        special: false,
        exclude: ['o', '0', 'l', '1']
      })
      this.setState({upload_code: random_code})
    }
    this.initFormValue()

  }

  initFormValue () {
    /*this.refs.car_cost.value = 0
     this.refs.car_sale_price.value = 0
     this.refs.car_cost_repair.value = 0
     this.refs.car_cost_tax.value = 0
     this.refs.car_cost_act.value = 0
     this.refs.car_cost_commissions.value = 0
     this.refs.car_cost_expenses_other.value = 0
     this.refs.car_net_profit.value = 0
     this.refs.car_cost_recipe_other.value = 0*/
  }

  handleUploadFile (event) {

    var input_file_name = event.target.name
    var that = this

    // alert(event.target.files[0]);
    // alert(this.state.upload_code);

    const data = new FormData()

    data.append('uploads', event.target.files[0], event.target.files[0].name)
    // data.append('file_upload', event.target.files[0]);
    data.append('upload_code', this.state.upload_code)
    data.append('user_created', 'admin')
    // data.append('car_upload_position', input_file_name);
    // console.log(data)
    // alert(this.state.upload_code)

    if (input_file_name === 'front_car') {
      this.refs.img_front_car.src = 'img/loading.gif'
      this.refs.img_front_car.height = 32
      data.append('car_upload_position', 'front_car')
    } else if (input_file_name === 'front_right') {
      this.refs.img_front_right.src = 'img/loading.gif'
      data.append('car_upload_position', 'front_right')
    } else if (input_file_name === 'front_left') {
      this.refs.img_front_left.src = 'img/loading.gif'
      data.append('car_upload_position', 'front_left')
    } else if (input_file_name === 'side_car_left') {
      this.refs.img_side_car_left.src = 'img/loading.gif'
      data.append('car_upload_position', 'side_car_left')
    } else if (input_file_name === 'side_car_right') {
      this.refs.img_side_car_right.src = 'img/loading.gif'
      data.append('car_upload_position', 'side_car_right')
    } else if (input_file_name === 'back_straight') {
      this.refs.img_back_straight.src = 'img/loading.gif'
      data.append('car_upload_position', 'back_straight')
    } else if (input_file_name === 'console_car') {
      this.refs.img_console_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'console_car')
    } else if (input_file_name === 'condition_in_car') {
      this.refs.img_condition_in_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'condition_in_car')
    } else if (input_file_name === 'engine_car') {
      this.refs.img_engine_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'engine_car')
    } else if (input_file_name === 'plate_car') {
      this.refs.img_plate_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'plate_car')
    } else if (input_file_name === 'other_car') {
      this.refs.img_other_car.src = 'img/loading.gif'
      data.append('car_upload_position', 'other_car')
      // add เพิ่ม
    } else if (input_file_name === 'console') {
      // 12.คอนโซล
      this.refs.img_console.src = 'img/loading.gif'
      data.append('car_upload_position', 'console')
    } else if (input_file_name === 'gear') {
      // 13.เกียร์
      this.refs.img_gear.src = 'img/loading.gif'
      data.append('car_upload_position', 'gear')
    } else if (input_file_name === 'audio_equipment') {
      // 14.เครื่องเสียง
      this.refs.img_audio_equipment.src = 'img/loading.gif'
      data.append('car_upload_position', 'audio_equipment')
    } else if (input_file_name === 'dial') {
      // 15) หน้าปัด
      this.refs.img_dial.src = 'img/loading.gif'
      data.append('car_upload_position', 'dial')
    }

    //alert(input_file_name)
    axios.post(APIURL + '/car_upload', data)
      .then(function (response) {
        let data = response.data
        let image_url = IMAGE_FULL_URL + data.image

        if(data.image === undefined) {
          image_url = IMAGE_UPLOAD_ERROR
        } else if (data.image === 'uploaderror') {
          image_url = IMAGE_UPLOAD_ERROR
        }

        // console.log('response:' , response)
        // console.log('input_file_name:' , input_file_name)
        // console.log('image_url:' , image_url)


        let img = new Image()
        img.src = image_url
        img.addEventListener('load', function () {

          if (input_file_name === 'front_car') {
            that.refs.img_front_car.src = image_url
          } else if (input_file_name === 'front_right') {
            that.refs.img_front_right.src = image_url
          } else if (input_file_name === 'front_left') {
            that.refs.img_front_left.src = image_url
          } else if (input_file_name === 'side_car_left') {
            that.refs.img_side_car_left.src = image_url
          } else if (input_file_name === 'side_car_right') {
            that.refs.img_side_car_right.src = image_url
          } else if (input_file_name === 'back_straight') {
            that.refs.img_back_straight.src = image_url
          } else if (input_file_name === 'console_car') {
            that.refs.img_console_car.src = image_url
          } else if (input_file_name === 'condition_in_car') {
            that.refs.img_condition_in_car.src = image_url
          } else if (input_file_name === 'engine_car') {
            that.refs.img_engine_car.src = image_url
          } else if (input_file_name === 'plate_car') {
            that.refs.img_plate_car.src = image_url
          } else if (input_file_name === 'other_car') {
            that.refs.img_other_car.src = image_url
            // add เพิ่ม
          } else if (input_file_name === 'console') {
            // 12
            that.refs.img_console.src = image_url
          } else if (input_file_name === 'gear') {
            // 13
            that.refs.img_gear.src = image_url
          } else if (input_file_name === 'audio_equipment') {
            // 14
            that.refs.img_audio_equipment.src = image_url
          } else if (input_file_name === 'dial') {
            // 15
            that.refs.img_dial.src = image_url
          }

        })

        //console.log(response);
      })
      .catch(function (error) {
         // console.log(error.response);
        // alert('error:' + error.response)
        if(error.response.status === 503) {
          let img = new Image()
          let image_url = IMAGE_UPLOAD_ERROR
          img.src = image_url
          img.addEventListener('load', () => {

            if (input_file_name === 'front_car2') {
              this.refs.img_front_car2.src = image_url
            } else if (input_file_name === 'front_right2') {
              this.refs.img_front_right2.src = image_url
            } else if (input_file_name === 'front_left2') {
              this.refs.img_front_left2.src = image_url
            } else if (input_file_name === 'side_car_left2') {
              this.refs.img_side_car_left2.src = image_url
            } else if (input_file_name === 'side_car_right2') {
              this.refs.img_side_car_right2.src = image_url
            } else if (input_file_name === 'back_straight2') {
              this.refs.img_back_straight2.src = image_url
            } else if (input_file_name === 'console_car2') {
              this.refs.img_console_car2.src = image_url
            } else if (input_file_name === 'condition_in_car2') {
              this.refs.img_condition_in_car2.src = image_url
            } else if (input_file_name === 'engine_car2') {
              this.refs.img_engine_car2.src = image_url
            } else if (input_file_name === 'plate_car2') {
              this.refs.img_plate_car2.src = image_url
            } else if (input_file_name === 'other_car2') {
              this.refs.img_other_car2.src = image_url
            }

          })
        }

      })

  }

  handleUploadFile2 (event) {

    var input_file_name = event.target.name

    // alert(event.target.files[0]);
    // alert(this.state.upload_code);

    const data = new FormData()

    data.append('uploads', event.target.files[0], event.target.files[0].name)
    // data.append('file_upload', event.target.files[0]);
    data.append('upload_code', this.state.upload_code)
    data.append('user_created', 'admin')
    // data.append('car_upload_position', input_file_name);
    // console.log(data)
    // alert(this.state.upload_code)

    if (input_file_name === 'front_car2') {
      this.refs.img_front_car2.src = 'img/loading.gif'
      this.refs.img_front_car2.height = 32
      data.append('car_upload_position', 'front_car2')
    } else if (input_file_name === 'front_right2') {
      this.refs.img_front_right2.src = 'img/loading.gif'
      data.append('car_upload_position', 'front_right2')
    } else if (input_file_name === 'front_left2') {
      this.refs.img_front_left2.src = 'img/loading.gif'
      data.append('car_upload_position', 'front_left2')
    } else if (input_file_name === 'side_car_left2') {
      this.refs.img_side_car_left2.src = 'img/loading.gif'
      data.append('car_upload_position', 'side_car_left2')
    } else if (input_file_name === 'side_car_right2') {
      this.refs.img_side_car_right2.src = 'img/loading.gif'
      data.append('car_upload_position', 'side_car_right2')
    } else if (input_file_name === 'back_straight2') {
      this.refs.img_back_straight2.src = 'img/loading.gif'
      data.append('car_upload_position', 'back_straight2')
    } else if (input_file_name === 'console_car2') {
      this.refs.img_console_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'console_car2')
    } else if (input_file_name === 'condition_in_car2') {
      this.refs.img_condition_in_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'condition_in_car2')
    } else if (input_file_name === 'engine_car2') {
      this.refs.img_engine_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'engine_car2')
    } else if (input_file_name === 'plate_car2') {
      this.refs.img_plate_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'plate_car2')
    } else if (input_file_name === 'other_car2') {
      this.refs.img_other_car2.src = 'img/loading.gif'
      data.append('car_upload_position', 'other_car2')
    }

    //alert(input_file_name)

    console.log(data)

    axios.post(APIURL + '/car_upload', data)
      .then(res => {
        let data = res.data
        let image_url = IMAGE_FULL_URL + data.image

        //console.log('image_url:' + image_url)

        if(data.image === undefined) {
          image_url = IMAGE_UPLOAD_ERROR
        } else if (data.image === 'uploaderror') {
          image_url = IMAGE_UPLOAD_ERROR
        }

        let img = new Image()
        img.src = image_url
        img.addEventListener('load', () => {

          if (input_file_name === 'front_car2') {
            this.refs.img_front_car2.src = image_url
          } else if (input_file_name === 'front_right2') {
            this.refs.img_front_right2.src = image_url
          } else if (input_file_name === 'front_left2') {
            this.refs.img_front_left2.src = image_url
          } else if (input_file_name === 'side_car_left2') {
            this.refs.img_side_car_left2.src = image_url
          } else if (input_file_name === 'side_car_right2') {
            this.refs.img_side_car_right2.src = image_url
          } else if (input_file_name === 'back_straight2') {
            this.refs.img_back_straight2.src = image_url
          } else if (input_file_name === 'console_car2') {
            this.refs.img_console_car2.src = image_url
          } else if (input_file_name === 'condition_in_car2') {
            this.refs.img_condition_in_car2.src = image_url
          } else if (input_file_name === 'engine_car2') {
            this.refs.img_engine_car2.src = image_url
          } else if (input_file_name === 'plate_car2') {
            this.refs.img_plate_car2.src = image_url
          } else if (input_file_name === 'other_car2') {
            this.refs.img_other_car2.src = image_url
          }

        })

        //console.log(response);
      })
      .catch(function (error) {
        // console.log(error.response);
        // alert('error:' + error.response)

        if(error.response.status === 503) {
          let img = new Image()
          let image_url = IMAGE_UPLOAD_ERROR
          img.src = image_url
          img.addEventListener('load', () => {

            if (input_file_name === 'front_car2') {
              this.refs.img_front_car2.src = image_url
            } else if (input_file_name === 'front_right2') {
              this.refs.img_front_right2.src = image_url
            } else if (input_file_name === 'front_left2') {
              this.refs.img_front_left2.src = image_url
            } else if (input_file_name === 'side_car_left2') {
              this.refs.img_side_car_left2.src = image_url
            } else if (input_file_name === 'side_car_right2') {
              this.refs.img_side_car_right2.src = image_url
            } else if (input_file_name === 'back_straight2') {
              this.refs.img_back_straight2.src = image_url
            } else if (input_file_name === 'console_car2') {
              this.refs.img_console_car2.src = image_url
            } else if (input_file_name === 'condition_in_car2') {
              this.refs.img_condition_in_car2.src = image_url
            } else if (input_file_name === 'engine_car2') {
              this.refs.img_engine_car2.src = image_url
            } else if (input_file_name === 'plate_car2') {
              this.refs.img_plate_car2.src = image_url
            } else if (input_file_name === 'other_car2') {
              this.refs.img_other_car2.src = image_url
            }

          })
        }

      })

  }

  handleOnChange () {

    var sale_price = this.state.car_sale_price
    var car_cost = this.state.car_cost
    var car_cost_repair = this.state.car_cost_repair
    var car_cost_tax = this.state.car_cost_tax
    var car_cost_act = this.state.car_cost_act
    var car_cost_commissions = this.state.car_cost_commissions
    var car_cost_expenses_other = this.state.car_cost_expenses_other
    var car_cost_recipe_other = this.state.car_cost_recipe_other


    if (car_cost === '')
      car_cost = 0

    if (car_cost_repair === '')
      car_cost_repair = 0

    if (car_cost_tax === '')
      car_cost_tax = 0

    if (car_cost_act === '')
      car_cost_act = 0

    if (car_cost_commissions === '')
      car_cost_commissions = 0

    if (car_cost_expenses_other === '')
      car_cost_expenses_other = 0

    if (car_cost_recipe_other === '')
      car_cost_recipe_other = 0

    var profite
    if (sale_price !== '' && sale_price > 0)
      profite = Number(sale_price) - Number(car_cost) - Number(car_cost_repair) - Number(car_cost_tax) - Number(car_cost_act) - Number(car_cost_commissions) - Number(car_cost_expenses_other) + Number(car_cost_recipe_other)
    else
      profite = 0

    this.setState({
      car_net_profit: profite
    })
  }

  handleOnChangeNoSet (event) {

  }

  componentWillMount () {
    this.setState({
      user: JSON.parse(this.props.user)
    })
  }

  handleCarDateIn(date) {
    this.setState({
      car_date_in: date
    })
  }

  //floorplan_due_date
  handleFloorplanDueDate(date) {
    this.setState({
      floorplan_due_date: date
    })
  }

  handleReceiptDate(date) {
    this.setState({
      receipt_date: date
    })
  }

  handleInsuranceEndDate(date) {
    this.setState({
      insurance_end_date: date
    })
  }

  // compulsory_insurance_end_date
  handleCompulsoryInsuranceEndDate(date) {
    this.setState({
      compulsory_insurance_end_date: date
    })
  }

  render () {

    //const {history, user} = this.props

    var car_brand_list = this.state.car_brands.map((car_brand, index) => {
      return (
        <option key={index} value={car_brand.car_brand_id}>{car_brand.car_brand_name}</option>
      )
    })
    var car_brand_model = this.state.car_models.map((car_model, index) => {
      return (
        <option key={index} value={car_model.car_model_id}>{car_model.car_model_name}</option>
      )
    })
    var car_sub_model = this.state.car_sub_models.map((car_sub_model, index) => {
      return (
        <option key={index} value={car_sub_model.car_sub_model_id}>{car_sub_model.car_sub_model_name}</option>
      )
    })
    var car_year_list = this.state.car_years.map((car_year, index) => {
      return (
        <option key={index} value={car_year.car_year_id}>{car_year.car_year_name}</option>
      )
    })
    var car_color_list = this.state.car_colors.map((car_color, index) => {
      return (
        <option key={index} value={car_color.car_color_id}>{car_color.car_color_name}</option>
      )
    })
    var car_gear_list = this.state.car_gears.map((car_gear, index) => {
      return (
        <option key={index} value={car_gear.car_gear_id}>{car_gear.car_gear_name}</option>
      )
    })
    var car_status_list = this.state.car_status.map((car_status, index) => {
      return (
        <option key={index} value={car_status.car_status_id}>{car_status.car_status_name}</option>
      )
    })

    var province_old_list = this.state.province.map((province, index) => {
      return (
        <option key={index} value={province.province_id}>{province.province_name}</option>
      )
    })

    var province_new_list = this.state.province.map((province, index) => {
      return (
        <option key={index} value={province.province_id}>{province.province_name}</option>
      )
    })

    var car_branch_list = this.state.branch.map((branch, index) => {
      return (
        <option key={index} value={branch.branch_id}>{branch.branch_name}</option>
      )
    })

    var car_hassock_list = this.state.car_hassock.map((car_hassock, index) => {
      return (
        <option key={index}
                value={car_hassock.car_hassock_id}>{car_hassock.car_hassock_name}</option>
      )
    })

    var car_system_drive_list = this.state.car_system_drive.map((car_system_drive, index) => {
      return (
        <option key={index}
                value={car_system_drive.car_system_drive_id}>{car_system_drive.car_system_drive_name}</option>
      )
    })

    var car_type_engine_list = this.state.car_type_engine.map((car_type_engine, index) => {
      return (
        <option key={index} value={car_type_engine.car_type_engine_id}>{car_type_engine.car_type_engine_name}</option>
      )
    })

    var car_type_list = this.state.car_type.map((car_type, index) => {
      return (
        <option key={index} value={car_type.car_type_id}>{car_type.car_type_name}</option>
      )
    })

    var car_structure_list = this.state.car_structure.map((car_structure, index) => {
      return (
        <option key={index} value={car_structure.car_structure_id}>{car_structure.car_structure_name}</option>
      )
    })

    var car_finance_list = this.state.banks.map((bank, index) => {
      if (bank.bank_id > 2) {
        return (
          <option key={index} value={bank.bank_id}>{index-1}.{bank.bank_name}</option>
        )
      } else {
        return null
      }
    });

    var car_floorplan_finance_list = this.state.banks.map((bank, index) => {
      if(port === '9005') {
        if (bank.bank_id > 2 && (bank.bank_name.includes('ทิสโก้') || bank.bank_name.includes('กรุงศรี'))) {
          return (
            <option key={index} value={bank.bank_id}>{bank.bank_name}</option>
          )
        } else {
          return null
        }
      }else{
        if (bank.bank_id > 2 ) {
          return (
            <option key={index} value={bank.bank_id}>{bank.bank_name}</option>
          )
        } else {
          return null
        }
      }
    });


    var insurance_types = this.state.insurance_types.map((insurance_type, index) => {
      return (
        <option key={index} value={insurance_type.insurance_type_id}>{insurance_type.insurance_type_name}</option>
      )
    })

    var insurance_companies = this.state.insurance_companies.map((insurance_company, index) => {
      return (
        <option key={index} value={insurance_company.insurance_company_id}>{insurance_company.insurance_company_name}</option>
      )
    })

    var compulsory_insurance_company = this.state.insurance_companies.map((insurance_company, index) => {
      return (
        <option key={index} value={insurance_company.insurance_company_id}>{insurance_company.insurance_company_name}</option>
      )
    })

    return (
      <div className="card">

        <Loading isLoading={this.state.isLoading} />

        <div className="card-block">
          <form action="" method="post" onSubmit={this.handleOnSubmitCar}>
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header card-header-info">
                    <strong>ข้อมูลเจ้าของเดิม</strong>
                  </div>
                  <div className="card-block">
                    <div className="row">
                      <div className="form-group col-sm-4">
                        <label htmlFor="name">ชื่อ</label>
                        <input type="text"
                               className="form-control"
                               name="car_name_owner_old"
                               ref="car_name_owner_old"
                               placeholder="กรอกชื่อ"/>
                      </div>
                      <div className="form-group col-sm-4">
                        <label htmlFor="lastname">นามสกุล</label>
                        <input type="text" className="form-control" name="car_lastname_owner_old"
                               placeholder="กรอกนามสกุล"/>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="id_card">เลขบัตรประจำตัวประชาชน</label>
                        <input type="text" className="form-control" name="car_id_card"
                               placeholder="เลขบัตรประจำตัวประชาชน" maxLength="13"/>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="license-plate-old">ป้ายทะเบียนเดิม *</label>
                        <input type="text" className="form-control" name="car_license_plate_old"
                               placeholder="ป้ายทะเบียนเดิม"/>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="province">จังหวัด</label>
                        <select className="form-control" id="province_old_id">
                          {province_old_list}
                        </select>
                      </div>

                      <div className="form-group col-sm-4">
                        <label htmlFor="telephone-old">เบอร์โทรศัพท์</label>
                        <input type="text" className="form-control" name="car_telephone_old"
                               placeholder=""/>
                      </div>

                      <div className="form-group col-sm-12">
                        <label htmlFor="address-old">ที่อยู่ตามทะเบียนบ้าน</label>
                        <input type="text" className="form-control" name="car_address_old"
                               placeholder="กรอกข้อมูลที่อยู่ตามทะเบียนบ้าน"/>
                      </div>

                      <div className="form-group col-sm-12">
                        <label htmlFor="other">หมายเหตุ</label>
                        <input type="text" className="form-control" name="car_other"
                               placeholder="ข้อมูลเพิ่มเติม"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header card-header-warning">
                    <strong>เพิ่มข้อมูลรถใหม่</strong>
                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row" style={styles.bottomLine}>

                          <div className="form-group col-sm-8">
                            <label htmlFor="branch">สาขาที่รถอยู่</label>
                            <select className="form-control" id="branch_id" ref="branch_id">
                              {car_branch_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car_date_in">วันที่ซื้อรถเข้ามา</label>
                            {/*<MaskedInput
                              mask="11-11-1111"
                              name="car_date_in_text"
                              placeholder="dd-mm-yyyy"
                              onChange={this.onMaskedChange1}
                              className="form-control"
                            />*/}
                            <br/>
                            <DatePicker
                             type="text"
                             className="form-control col-sm-12"
                             name="car_date_in"
                             placeholder=""
                             selected={this.state.car_date_in}
                             onChange={this.handleCarDateIn}
                             dateFormat="yyy-MM-dd"
                             />
                          </div>

                          <div className="form-group col-sm-12">
                            <label htmlFor="car_name">ชื่อรถ</label>
                            <input type="text"
                                   className="form-control"
                                   id="car_name"
                                   name="car_name"
                                   ref="car_name"
                                   value={this.state.car_name}
                                   placeholder="ชื่อรถ-สร้างอัตโนมัติ เลือกยี่ห้อ รุ่น สี "
                                   onChange={this.handleCarNameChange}
                            />
                          </div>

                          <div className="form-group col-sm-12">
                            <label htmlFor="detail">รายละเอียดรถ</label>
                            <input
                              type="text" className="form-control"
                              id="car_detail"
                              name="car_detail"
                              ref="car_detail"
                              value={this.state.car_detail}
                              placeholder="รายละเอียดรถ"
                              onChange={this.handleCarDetailChange}
                            />
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car_brand_id">ยี่ห้อ</label>
                            <select className="form-control"
                                    id="car_brand_id"
                                    name="car_brand_id"
                                    ref="car_brand_id"
                                    onChange={this.handleCarBrandChange.bind(this)}
                            >
                              <option value="">เลือกยี่ห้อรถ</option>
                              {car_brand_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car_model_id">รุ่นรถ</label>
                            <select className="form-control"
                                    id="car_model_id"
                                    name="car_model_id"
                                    onChange={this.handleCarModelChange.bind(this)}
                            >
                              <option value="">เลือกรุ่นรถ</option>
                              {car_brand_model}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car_sub_model_id">รุ่นย่อย</label>
                            <select className="form-control"
                                    id="car_sub_model_id"
                                    name="car_sub_model_id"
                                    ref="car_sub_model"
                                    onChange={this.handleCarSubModelChange}
                            >
                              <option value="">เลือกรุ่นย่อย</option>
                              {car_sub_model}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="gear">ระบบเกียร์รถ</label>
                            <select
                              className="form-control"
                              id="car_gear_id"
                              name="car_gear_id"
                              onChange={this.handleCarGearChange}
                            >
                              {car_gear_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="color">สี</label>
                            <select className="form-control"
                                    id="car_color_id"
                                    name="car_color_id"
                                    onChange={this.handleCarColorChange}
                            >
                              {car_color_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="year">รถปี ค.ศ.</label>
                            <select className="form-control"
                                    id="car_year_id"
                                    name="car_year_id"
                                    onChange={this.handleCarYearChange.bind(this)}
                            >
                              {car_year_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="license-plate-new">ป้ายทะเบียนใหม่ *</label>
                            <input type="text"
                                   className="form-control"
                                   name="car_license_plate_new"
                                   placeholder="กข-xxx"/>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="province">จังหวัด</label>
                            <select className="form-control" id="province_new_id">
                              {province_new_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="miles">เลขไมล์ปัจจุบัน</label>
                            <input type="text"
                                   className="form-control hidden"
                                   id="car_miles"
                                   name="car_miles"
                                   placeholder="เลขไมล์ปัจจุบัน"
                                   value={this.state.car_miles}
                                   onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              placeholder="เลขไมล์ปัจจุบัน"
                              min={0}
                              max={1000000000}
                              step={1}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_miles: value})

                              }}
                            />
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car-number">เลขตัวรถ</label>
                            <input style={styles.toUpper}
                                   type="text"
                                   className="form-control"
                                   name="car_number"
                                   placeholder="000-001001"/>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="num-engines">เลขเครื่องยนต์</label>
                            <input style={styles.toUpper}
                                   type="text"
                                   className="form-control"
                                   name="car_num_engines"
                                   placeholder="AB00A-xxxx"
                            />
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car_date_regis_text">วันที่จดทะเบียน (วัน-เดือน-ปีพ.ศ.)</label>

                            <MaskedInput
                              mask="11-11-1111"
                              id="car_date_regis_text"
                              name="car_date_regis_text"
                              placeholder="dd-mm-yyyy"
                              onChange={this.onMaskedChange3}
                              className="form-control"
                            />
                            {/*<DatePicker
                             type="text"
                             className="form-control hidden"
                             name="car_date_regis"
                             placeholder=""
                             selected={this.state.startDateCarNew3}
                             onChange={this.handleDateCarNew3}
                             dateFormat="YYYY-MM-DD"

                             />*/}
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="type">ประเภท</label>
                            <select className="form-control" id="car_type_id">
                              {car_type_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="structure">ลักษณะ</label>
                            <select className="form-control" id="car_structure_id">
                              {car_structure_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="hassock">เบาะรถ</label>
                            <select className="form-control" id="car_hassock_id">
                              {car_hassock_list}
                            </select>
                          </div>

                          <div
                            className={
                              this.state.form_controls.length > 0 ?
                              (this.state.form_controls.filter(form_control => form_control.field_name === 'car_system_drive_id' ))[0].visibility===0 ? "hidden" : "form-group col-sm-4"
                              :  "hidden"
                            }
                          >
                            <label htmlFor="system-drive">ระบบขับเคลื่อน</label>
                            <select
                              className="form-control"
                              id="car_system_drive_id"
                              name="car_system_drive_id"
                            >
                              {car_system_drive_list}
                            </select>
                          </div>

                          <div
                            className={
                              this.state.form_controls.length > 0 ?
                                (this.state.form_controls.filter(form_control => form_control.field_name === 'car_type_engine_id' ))[0].visibility===0 ? "hidden" : "form-group col-sm-4"
                                :  "hidden"
                            }
                          >
                            <label htmlFor="type-engine">ประเภทเครื่องยนต์</label>
                            <select className="form-control"
                                    id="car_type_engine_id"
                                    name="car_type_engine_id"
                            >
                              {car_type_engine_list}
                            </select>
                          </div>

                          <div
                            className={
                              this.state.form_controls.length > 0 ?
                                (this.state.form_controls.filter(form_control => form_control.field_name === 'car_brand_engine' ))[0].visibility===0 ? "hidden" : "form-group col-sm-4"
                                :  "hidden"
                            }
                          >
                            <label htmlFor="brand-engine">ยี่ห้อเครื่องยนต์</label>
                            <input type="text" className="form-control"
                                   id="car_brand_engine"
                                   name="car_brand_engine"
                                   placeholder="ยี่ห้อเครื่องยนต์"/>
                          </div>

                          <div
                            className={
                              this.state.form_controls.length > 0 ?
                                (this.state.form_controls.filter(form_control => form_control.field_name === 'car_gas_number' ))[0].visibility===0 ? "hidden" : "form-group col-sm-4"
                                :  "hidden"
                            }
                          >
                            <label htmlFor="gas-number">เลขถังแก๊ส</label>
                            <input type="text" className="form-control"
                                   id="car_gas_number"
                                   name="car_gas_number"
                                   placeholder="เลขถังแก๊ส"/>
                          </div>

                          <div
                            className={
                              this.state.form_controls.length > 0 ?
                                (this.state.form_controls.filter(form_control => form_control.field_name === 'car_weight' ))[0].visibility===0 ? "hidden" : "form-group col-sm-4"
                                :  "hidden"
                            }
                          >
                            <label htmlFor="weight">น้ำหนักรถ (กิโลกรัม)</label>
                            <input type="text" className="form-control"
                                   id="car_weight"
                                   name="car_weight"
                                   placeholder="น้ำหนักรถ (กิโลกรัม)"/>
                          </div>

                          <div
                            className={
                              this.state.form_controls.length > 0 ?
                                (this.state.form_controls.filter(form_control => form_control.field_name === 'car_size_engine' ))[0].visibility===0 ? "hidden" : "form-group col-sm-4"
                                :  "hidden"
                            }
                          >
                            <label htmlFor="size-engine">ขนาดเครื่องยนต์ (ซีซี)/ แรงม้า</label>
                            <input type="text" className="form-control"
                                   id="car_size_engine"
                                   name="car_size_engine"
                                   placeholder="ขนาดเครื่องยนต์ (ซีซี) / แรงม้า"/>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car_date_tax_text">วันครบกำหนดเสียภาษี (วัน-เดือน-ปีพ.ศ.)</label>
                            <MaskedInput
                              mask="11-11-1111"
                              id="car_date_tax_text"
                              name="car_date_tax_text"
                              placeholder="dd-mm-yyyy"
                              onChange={this.onMaskedChange2}
                              className="form-control"
                            />
                            {/*<DatePicker
                             selected={this.state.startDateCarNew2}
                             onChange={this.handleDateCarNew2}
                             dateFormat="YYYY-MM-DD"
                             type="text"
                             className="form-control"
                             name="car_date_tax"
                             placeholder=""
                             />*/}
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="tax-price">ราคาภาษีรถยนต์ / ปี</label>
                            <input type="text" className="form-control" name="car_tax"
                                   placeholder="ราคาภาษีรถยนต์ / ปี"/>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="status">สถานะรถ</label>
                            <select className="form-control" id="car_status_id">
                              {car_status_list}
                            </select>
                          </div>

                        </div>

                        <div className="row" style={styles.bottomLine}>
                          <div className="form-group col-sm-4">
                            <label htmlFor="compulsory_insurance">พรบ.</label>
                            <select className="form-control"
                                    id="compulsory_insurance"
                                    name="compulsory_insurance"
                                    onChange={(event) => {
                                      var value  = event.target.value
                                      //alert(value)
                                      if(value === 'ไม่มี') {
                                        this.refs.compulsory_insurance_company.value = 99
                                      }
                                    }}
                            >
                              <option value="">-- กรุณาเลือก --</option>
                              <option value="มี">มี</option>
                              <option value="ไม่มี">ไม่มี</option>
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="compulsory_insurance_company">บ.พรบ</label>
                            <select className="form-control"
                                    id="compulsory_insurance_company"
                                    name="compulsory_insurance_company"
                                    ref="compulsory_insurance_company"
                            >
                              <option value="">-- กรุณาเลือก --</option>
                              {compulsory_insurance_company}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="compulsory_insurance_end_date">วันที่สิ้นสุด พรบ.</label>
                            <br/>
                            <DatePicker
                              type="text"
                              className="form-control col-sm-12"
                              name="compulsory_insurance_end_date"
                              placeholder=""
                              selected={this.state.compulsory_insurance_end_date}
                              value={this.state.compulsory_insurance_end_date}
                              onChange={this.handleCompulsoryInsuranceEndDate}
                              dateFormat="yyy-MM-dd"
                            />
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car_spare_key">กุญแจสำรอง</label>
                            <select className="form-control"
                                    id="car_spare_key"
                                    name="car_spare_key"
                            >
                              <option value="">-- กรุณาเลือก --</option>
                              <option value="มี">มี</option>
                              <option value="ไม่มี">ไม่มี</option>
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="car_spare_key">คู่มือ</label>
                            <select className="form-control"
                                    id="car_manual"
                                    name="car_manual"
                            >
                              <option value="">-- กรุณาเลือก --</option>
                              <option value="มี">มี</option>
                              <option value="ไม่มี">ไม่มี</option>
                            </select>
                          </div>

                        </div>


                        <div className="row" style={styles.bottomLine}>
                          <div className="form-group col-sm-4">
                            <label htmlFor="insurance_type_id">ประเภทประกันภัย</label>
                            <select
                              className="form-control"
                              id="insurance_type_id"
                              onChange={(event) => {
                                var value  = event.target.value
                                //alert(value)
                                if(value === 6) {
                                  this.refs.insurance_company_id.value = 99
                                }
                              }}
                            >
                              {insurance_types}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="insurance_company_id">บ.ประกันภัย</label>
                            <select className="form-control"
                                    id="insurance_company_id"
                                    ref="insurance_company_id"
                            >
                              {insurance_companies}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="insurance_end_date">วันที่สิ้นสุดประกัน</label>
                            <br/>
                            <DatePicker
                              type="text"
                              className="form-control col-sm-12"
                              name="insurance_end_date"
                              placeholder=""
                              selected={this.state.insurance_end_date}
                              value={this.state.insurance_end_date}
                              onChange={this.handleInsuranceEndDate}
                              dateFormat="yyy-MM-dd"
                            />
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="deposit_registration_id">มัดจำเล่มทะเบียน</label>
                            <select className="form-control"
                                    id="deposit_registration_id">
                              <option value="1">มัดจำเล่ม</option>
                              <option value="2">ไม่มัดจำ</option>
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="liciense_status_id">สถานะเล่ม</label>
                            <select className="form-control"
                                    id="liciense_status_id">
                              <option value="1">มีเล่มทะเบียน</option>
                              <option value="2">ยังไม่ปิดบัญชี</option>
                              <option value="3">รอเล่มปิดบัญชี</option>
                              <option value="4">มีเล่มอยู่เต็นท์</option>
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="finance_id">ไฟแนนซ์รอเล่มทะเบียน</label>
                            <select className="form-control" id="finance_id">
                              <option value="0"> --- เลือกไฟแนนซ์ --- </option>
                              {car_finance_list}
                            </select>
                          </div>


                          <div className="form-group col-sm-4">
                            <label htmlFor="receipt_date">วันที่รับเล่ม</label>
                            <br/>
                            <DatePicker
                              type="text"
                              className="form-control col-sm-12"
                              name="receipt_date"
                              placeholder=""
                              selected={this.state.receipt_date}
                              value={this.state.receipt_date}
                              onChange={this.handleReceiptDate}
                              dateFormat="yyy-MM-dd"
                            />
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="floorplan_credit">ยอดเงินฟลอร์แพลน(จำนวนเงิน)</label>
                            <input type="text"
                                   className="form-control hidden "
                                   name="floorplan_credit"
                                   placeholder=""
                                   ref="floorplan_credit"
                                   value={this.state.floorplan_credit}
                                   onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="ยอดเงินฟลอร์แพลน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({floorplan_credit: value})
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="finance_floorplan_id">ไฟแนนซ์ฟลอร์แพลน</label>
                            <select className="form-control" id="finance_floorplan_id">
                              <option value="0"> --- เลือกไฟแนนซ์ฟลอร์แพลน --- </option>
                              {car_floorplan_finance_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-4">
                            <label htmlFor="floorplan_due_date">วันครบกำหนดเล่มฟลอร์แพลน</label>
                            <br/>
                            <DatePicker
                              type="text"
                              className="form-control col-sm-12"
                              name="floorplan_due_date"
                              placeholder=""
                              selected={this.state.floorplan_due_date}
                              value={this.state.floorplan_due_date}
                              onChange={this.handleFloorplanDueDate}
                              dateFormat="yyy-MM-dd"
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header card-header-info">
                    <strong>เพิ่มรูปรถ</strong>
                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="form-group col-sm-2">
                        <label htmlFor="name">1) หน้าตรง <span className="text-danger">**</span></label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_front_car"
                                 alt="หน้ารถ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="front_car"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">2) หน้าซ้าย</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_front_right"
                                 alt="มุมขวา"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="front_right"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">3) หน้าขวา</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_front_left"
                                 alt="มุมซ้าย"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="front_left"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">4) หลังตรง </label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_side_car_left"
                                 alt="ด้านซ้าย"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="side_car_left"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">5) หลังซ้าย</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_side_car_right"
                                 alt="ด้านขวา"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="side_car_right"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">6) หลังขวา</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_back_straight"
                                 alt="มุมตรง"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="back_straight"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">7) ซ้ายตรง</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_console_car"
                                 alt="คอนโซลรถ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="console_car"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">8) ขวาตรง</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_condition_in_car"
                                 alt="สภาพภายในรถ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="condition_in_car"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">9) เครื่องยนต์</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_engine_car"
                                 alt="เครื่องยนต์"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="engine_car"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">10) เบาะหน้าขวา</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_plate_car"
                                 alt="เพลทรถยนต์"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="plate_car"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">11) เบาะหลังขวา</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_other_car"
                                 alt="ภาพอื่นๆ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="other_car"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">12) คอนโซล</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_console"
                                 alt="ภาพอื่นๆ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="console"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">13) เกียร์</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_gear"
                                 alt="เกียร์"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="gear"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">14) เครื่องเสียง</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_audio_equipment"
                                 alt="เครื่องเสียง"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="audio_equipment"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">15) หน้าปัด</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_dial"
                                 alt="หน้าปัด"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="dial"
                            onChange={this.handleUploadFile}
                          />
                        </div>
                      </div>

                    </div>

                    <div className="row"><span className="text-danger">**</span>&nbsp;เลือกอย่างน้อยภาพหน้ารถ &nbsp;&nbsp; สามารถเพิ่มเติมหรือปรับเปลี่ยนภายหลังได้</div>
                  </div>
                </div>
              </div>

              <div className={PORT === '9006' || PORT === '9000' ? "col-sm-12" : "hidden" } >
                <div className="card">
                  <div className="card-header card-header-info">
                    <strong>เพิ่มรูปรถ(ก่อนแต่ง)</strong>
                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="form-group col-sm-2">
                        <label htmlFor="name">
                          1) หน้ารถ หน้าตรง <span className="text-danger hidden">**</span>
                        </label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_front_car2"
                                 alt="หน้ารถ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="front_car2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">2) หน้ารถ มุมขวา</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_front_right2"
                                 alt="มุมขวา"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="front_right2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">3) หน้ารถ มุมซ้าย</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_front_left2"
                                 alt="มุมซ้าย"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="front_left2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">4) ข้างรถ ด้านซ้าย</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_side_car_left2"
                                 alt="ด้านซ้าย"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="side_car_left2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">5) ข้างรถ ด้านขวา</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_side_car_right2"
                                 alt="ด้านขวา"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="side_car_right2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">6) หลังรถ มุมตรง</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_back_straight2"
                                 alt="มุมตรง"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="back_straight2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">7) คอนโซลรถ</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_console_car2"
                                 alt="คอนโซลรถ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="console_car2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">8) สภาพภายในรถ</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_condition_in_car2"
                                 alt="สภาพภายในรถ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="condition_in_car2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">9) เครื่องยนต์</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_engine_car2"
                                 alt="เครื่องยนต์"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="engine_car2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">10) เพลทรถยนต์</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_plate_car2"
                                 alt="เพลทรถยนต์"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="plate_car2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                      <div className="form-group col-sm-2">
                        <label htmlFor="name">11) ภาพอื่นๆ</label>
                        <div style={styles.fileInputWrapper}>
                          <button style={styles.btnFileInput}>
                            <img src={'img/add_image.png'}
                                 style={styles.btnFileInputImage}
                                 ref="img_other_car2"
                                 alt="ภาพอื่นๆ"
                            />
                          </button>
                          <input
                            style={styles.fileInput}
                            type="file" name="other_car2"
                            onChange={this.handleUploadFile2}
                          />
                        </div>
                      </div>

                    </div>

                    <div className="row hidden"><span className="text-danger">**</span>&nbsp;เลือกอย่างน้อยภาพหน้ารถ &nbsp;&nbsp; สามารถเพิ่มเติมหรือปรับเปลี่ยนภายหลังได้</div>
                  </div>
                </div>
              </div>


              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header card-header-warning">
                    <strong>ราคา/ค่าใช้จ่าย</strong>
                  </div>

                  <div className="card-block">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">

                          <div className="form-group col-sm-6">
                            <label htmlFor="cost">ราคาซื้อ</label>
                            <input type="text"
                                   className="form-control hidden "
                                   name="car_cost"
                                   placeholder=""
                                   ref="car_cost"
                                   value={this.state.car_cost}
                                   onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="ราคาซื้อ"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_cost: value}, () => {
                                  this.handleOnChange()
                                })

                              }}
                            />
                          </div>

                          <div className="form-group col-sm-6">
                            <label htmlFor="sale-price">ราคาขาย</label>
                            <input type="text"
                                   className="form-control hidden"
                                   name="car_sale_price"
                                   placeholder=""
                                   ref="car_sale_price"
                                   value={this.state.car_sale_price}
                                   onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="ราคาขาย"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_sale_price: value}, () => {
                                  this.handleOnChange()
                                })

                              }}
                            />
                          </div>

                          <div className="form-group col-sm-6">
                            <label htmlFor="cost-repair">ค่าซ่อมบำรุง</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="car_cost_repair"
                              placeholder=""
                              ref="car_cost_repair"
                              value={this.state.car_cost_repair}
                              onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="ค่าซ่อมบำรุง"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                //if(value==='')
                                //alert('ค่าซ่อมบำรุง=0')
                                this.setState({car_cost_repair: value}, () => {
                                  this.handleOnChange()
                                })

                              }}
                            />
                          </div>

                          <div className="form-group col-sm-6">
                            <label htmlFor="cost-tax">ค่าภาษีรถยนต์</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="car_cost_tax"
                              placeholder=""
                              ref="car_cost_tax"
                              value={this.state.car_cost_tax}
                              onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="ค่าภาษีรถยนต์"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_cost_tax: value}, () => {
                                  this.handleOnChange()
                                })

                              }}
                            />
                          </div>

                          <div className="form-group col-sm-6">
                            <label htmlFor="cost-act">ค่าใช้จ่าย พ.ร.บ.</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="car_cost_act"
                              placeholder=""
                              ref="car_cost_act"
                              value={this.state.car_cost_act}
                              onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="ค่าใช้จ่าย พ.ร.บ."
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_cost_act: value}, () => {
                                  this.handleOnChange()
                                })
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-6">
                            <label htmlFor="cost-commissions">ค่าคอมมิชชั่น</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="car_cost_commissions"
                              placeholder=""
                              ref="car_cost_commissions"
                              value={this.state.car_cost_commissions}
                              onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="ค่าคอมมิชชั่น"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_cost_commissions: value}, () => {
                                  this.handleOnChange()
                                })
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-6">
                            <label htmlFor="cost-expenses-other">ค่าใช้จ่ายอื่นๆ</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="car_cost_expenses_other"
                              placeholder=""
                              ref="car_cost_expenses_other"
                              value={this.state.car_cost_expenses_other}
                              onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="ค่าใช้จ่ายอื่นๆ"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_cost_expenses_other: value}, () => {
                                  this.handleOnChange()
                                })
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-6">
                            <label htmlFor="cost-recipe-other">รายรับอื่นๆจากการขาย</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="car_cost_recipe_other"
                              placeholder=""
                              ref="car_cost_recipe_other"
                              value={this.state.car_cost_recipe_other}
                              onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="รายรับอื่นๆจากการขาย"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_cost_recipe_other: value}, () => {
                                  this.handleOnChange()
                                })
                              }}
                            />
                          </div>

                          <div className="form-group has-warning col-sm-12">
                            <label htmlFor="net-profit">กำไรสุทธิ</label>
                            <input type="text"
                                   className="form-control hidden"
                                   name="car_net_profit"
                                   placeholder="กำไรสุทธิ"
                                   ref="car_net_profit"
                                   value={this.state.car_net_profit}
                                   onChange={this.handleOnChangeNoSet}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              placeholder="กำไรสุทธิ"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.car_net_profit}
                              displayType="text"
                            />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 text-center">
                <div className="card-block">
                  <button type="submit" className="btn btn-success btn-lg"><i
                    className="icon-check"></i> บันทึกข้อมูลรถใหม่
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(CarNew)

const styles = {
  fileInputWrapper: {
    position: 'relative',
    overflow: 'hidden',
    height: 100,
    width: 100,
  },
  btnFileInput: {
    width: 100,
    height: 100,
    display: 'inline-block',
    backgroundColor: '#D2DDE2',
    backgroundImage: 'linear-gradient(to bottom, #D2DDE2, #FCF8FF)',
    backgroundRepeat: 'repeat-x',

    color: '#ffffff',
    textShadow: '0 -1px 0 rgba(0, 0, 0, 0.25)'
  },
  btnFileInputImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 100,
    height: 100
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    right: 0,
    opacity: 0,
    height: 100,
    width: 100,
    cursor: 'pointer'
  },
  toUpper: {
    textTransform: 'uppercase',
  },
  bottomLine: {
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
    borderWidth: 0.5,
    marginTop: 16,
  },
}
